import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HeroVideo } from "Components/Video";
import { HeroText } from "Components/HeroText/HeroText";

export const VideoBlock = ({ FullHeight, ...rest }) => {
	const [height, setHeight] = useState("450px");
	useEffect(() => {
		if (FullHeight) {
			let headerHeight = document.getElementById("divider").style.height;
			setHeight(`calc(100vh - ${headerHeight})`);
		}
	}, []);

	return <HeroVideo {...{ height }} {...rest}></HeroVideo>;
};

VideoBlock.propTypes = {};
